export default {
  LOADING_STATES: 'ADMIN_VIEW_MARKET_EDITOR_LOADING_STATES',
  LOADED_STATES: 'ADMIN_VIEW_MARKET_EDITOR_LOADED_STATES',
  UPDATING: 'ADMIN_VIEW_MARKET_EDITOR_UPDATING',
  UPDATED: 'ADMIN_VIEW_MARKET_EDITOR_UPDATED',
};
